/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Add_StageInputs */

const cs_pipelines_add_stage = /** @type {(inputs: Pipelines_Add_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidat fázi`)
};

const en_pipelines_add_stage = /** @type {(inputs: Pipelines_Add_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add stage`)
};

/**
* | output |
* | --- |
* | "Add stage" |
*
* @param {Pipelines_Add_StageInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_add_stage = /** @type {((inputs?: Pipelines_Add_StageInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Add_StageInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_add_stage(inputs)
	return cs_pipelines_add_stage(inputs)
});